export default "__VITE_ASSET__BZPoAlj$__"